export default __webpack_public_path__ + "static/media/play.17f45f3a.svg";